/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import WeekDays from '@/model/dataLayer/api/common/WeekDays'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      disableNew: true,
      disableEdit: true,
      requiredNew: false
    }
  },
  weekday: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: WeekDays.getList(),
        multiple: true,
        disableEdit: true,
        itemText: 'name'
      }
    }
  },
  startTime: {
    type: IKDataEntity.Types.Time
  },
  endTime: {
    type: IKDataEntity.Types.Time
  }
}
const config = {
  add: function (item) {
    return hillo.post('Takeaway.php?op=addOpeningTime', item, {
      showLoading: true
    })
  },
  edit: function (item) {
    // item.weekday = item.weekday.join(',')
    return hillo.postWithUploadFile('Takeaway.php?op=updateOpeningTime', item, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('Takeaway.php?op=deleteOpeningTime', { id }, {
      showLoading: true
    })
  },
  load: async function (filter) {
    return (await hillo.get('Takeaway.php?op=showAllOpeningTime', { purpose: filter[0] ?? 'general' }))
      .content
  }
}
export default IKDataEntity.ModelFactory(entity, config)
